import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'eic-display-contact',
  templateUrl: './display-contact.component.html',
  styleUrls: ['../../project-display.styles.scss',
              './display-contact.component.scss']
})
export class DisplayContactComponent implements OnInit {
  @Input() contact: any;

  displayName: string;
  jobTitle: any;
  phoneNumber: string;
  emailAddress: string;

  searchTerm: any;

  ngOnInit() {
    this.displayName = !(this.contact?.displayName) ? "" : this.contact.displayName + ": ";
    this.jobTitle = !(this.contact?.jobTitle) ? "" : this.contact.jobTitle;
    this.phoneNumber = !(this.contact?.phoneNumber) ? "" : "<br>tel: " + this.contact.phoneNumber;
    this.emailAddress = !(this.contact?.emailAddress) ? "" : "<br>" + this.contact.emailAddress;
  }

}
